import { FsCard, FsH2 } from '@aviatrix/flights';
import React from 'react';

const NotFound = ()=>{
    return (
        <div className="page">
            <FsCard variant='sm' className="page-content">
                <FsH2>Page not found !</FsH2>
            </FsCard>
        </div>
    )
}

export default NotFound;